import { useTranslation } from "react-i18next";
import FilterableTableLayout from "../../../components/FilterableTableLayout/FilterableTableLayout";
import {
  getProdukcioniKodIzvodFilterItems,
  getProdukcioniKodIzvodTableColumns,
  PRODUKCIONI_KOD_IZVOD_INITIAL_FILTERS,
  PRODUKCIONI_KOD_IZVOD_INITIAL_PAGINATION,
} from "../../../modules/productionCode/productionCode.constants";
import { useProdukcioniKodoviListaIzvoda } from "../../../modules/productionCode/productionCode.queries";
import {
  ProdukcioniKodIzvod,
  ProdukcioniKodIzvodPayload,
  ProdukcioniKodIzvodResponse,
} from "../../../modules/productionCode/productionCode.types";
import style from "./ProdukcioniKodoviListaIzvodaPage.module.scss";

const ProdukcioniKodoviListaIzvodaPage = () => {
  const { t } = useTranslation();

  return (
    <FilterableTableLayout<
      ProdukcioniKodIzvod,
      ProdukcioniKodIzvodResponse,
      ProdukcioniKodIzvodPayload
    >
      tableName="produkcioni_kod_izvod_table"
      toolbarId="produkcioni_kod_izvod_list"
      dataListKey="list"
      title={t("QR_CODE.LISTA_IZVODA_ZA_PRODUKCIONE_KODOVE")}
      tableRowKey="id"
      getTableColumns={() => getProdukcioniKodIzvodTableColumns()}
      queryHook={useProdukcioniKodoviListaIzvoda}
      filterProps={{
        getFilterItems: getProdukcioniKodIzvodFilterItems,
        initialFilters: PRODUKCIONI_KOD_IZVOD_INITIAL_FILTERS,
        filterToolbarClassName: style.filterToolbar,
        triggerQueryManually: true,
      }}
      paginationProps={{
        enableAPIPagination: true,
        initialPagination: PRODUKCIONI_KOD_IZVOD_INITIAL_PAGINATION,
        totalCountKey: "total",
      }}
    />
  );
};

export default ProdukcioniKodoviListaIzvodaPage;
